import React, { createContext, useContext } from 'react';
import useClientPreferences from '@shared/api/useClientPreferences';

export interface ClientPreferences {
  accessOnlyForLoggedInUsers: boolean;
  validateSaWorkspaceEnabled: boolean;
  serviceAccountWorkspacesLimit: number;
}

const initialData: ClientPreferences = {
  accessOnlyForLoggedInUsers: false,
  validateSaWorkspaceEnabled: false,
  serviceAccountWorkspacesLimit: 1
};

const ClientPreferencesContext = createContext<ClientPreferences>(initialData);

export const useClientPreferencesContext = () => {
  const clientPreferences = useContext(ClientPreferencesContext);

  return clientPreferences;
};

interface ClientPreferencesProviderProps {
  children: React.ReactNode;
}

const ClientPreferencesProvider = ({
  children
}: ClientPreferencesProviderProps) => {
  const { data } = useClientPreferences({
    refetchOnMount: true,
    initialData
  });
  const clientPreferences = data as ClientPreferences;

  return (
    <ClientPreferencesContext.Provider value={clientPreferences}>
      {children}
    </ClientPreferencesContext.Provider>
  );
};

export default ClientPreferencesProvider;
